<template>
  <div class="my-4">
    <v-card class="msg my-2">
      <div class="user-icon"><span class="user-letter">{{ userLetter }}</span></div>
      <p class="user-msg mt-2 mb-2">{{ userMessage }}</p>
    </v-card>
    <v-card class="msg">
      <div v-if="agentMessageFormatted !== ''">
         <Code :msg="agentMessageFormatted" />
      </div>
      <div v-else class="chat-bubble">
        <div class="typing">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
    </v-card>
  </div>
</template>
<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { marked } from 'marked'
import Prism from 'prismjs'
import 'prismjs/themes/prism-okaidia.css'
import { mapState } from 'vuex'
import { hash } from '@/utils/general'
import Code from './Code.vue'

@Options({
  props: {
    id: String,
    userMessage: String,
    agentMessage: String
  },
  computed: {
    ...mapState(['username', 'firstname']),
  },
  components: {
    Code
  }
})
export default class ChatMessage extends Vue {
  id!: string
  username!: string
  firstname!: string
  userMessage!: string
  userMsgHash: string = ''
  agentMessage!: string
  agentMsgHash: string = ''
  userMessageFormatted: string = ''
  agentMessageFormatted: string = ''

  get usernameDisplay(): string {
    if (this.firstname == null || this.firstname == '') {
      return this.username
    } else if (this.firstname != null && this.firstname != '') {
      return this.firstname 
    }
    return this.username
  }

  get userLetter() {
    if (this.usernameDisplay != null && this.usernameDisplay.trim().length > 0) {
      return this.usernameDisplay.charAt(0).toUpperCase()
    }
    return '?'
  }

  async mounted() {
    await this.updateMessages()
  }

  async updated() {
    await this.updateMessages()
  }

  async updateMessages() {
    const agentMsgHash = hash(this.agentMessage)
    const userMsgHash = hash(this.userMessage)
    if ((this.agentMessage != null && this.agentMessage !== '') && (agentMsgHash !== this.agentMsgHash || userMsgHash !== this.userMsgHash)) {
      this.agentMessageFormatted = await this.formatMarkdown(this.agentMessage)
      // this.renderMarkdown()
      this.agentMsgHash = agentMsgHash
      this.userMsgHash = userMsgHash
      console.log('Messages updated')
    }
  }

  async formatMarkdown(text: string): Promise<string> {
    return marked.parse(text)
  }

  renderMarkdown() {
    Prism.highlightAll()
  }

}
</script>
<style scoped lang="scss">
  .events-list {
    li {
      list-style: none;
      // padding-left: 20px;
    }
  }
  .user-icon {
    width: 30px;
    height: 30px;
    background: rgb(var(--v-theme-primary));
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    &.smaller {
      width: 27px;
      height: 27px;

      .user-letter {
        font-size: 14px;
      }
    }

    .user-letter {
      color: rgb(var(--v-theme-surface));
      font-family: system-ui, -apple-system, sans-serif;
      font-size: 16px;
      font-weight: bold;
      // font-weight: 500;
      line-height: 1;
      text-transform: uppercase;
      user-select: none;
    }
  }
  .chat-bubble {
    // background: #e6e6e6;
    // top: -30px;
    margin-left: -20px;
    border-radius: 15px;
    padding: 15px 25px;
    display: inline-block;
    position: relative;

    .typing {
      display: flex;
      gap: 4px;
      align-items: center;
      height: 17px;
    }

    .dot {
      width: 7px;
      height: 7px;
      background: #757575;
      border-radius: 50%;
      animation: bounce 1.8s linear infinite;
    }

    .dot:nth-child(2) {
      animation-delay: 0.3s;
    }

    .dot:nth-child(3) {
      animation-delay: 0.6s;
    }
  }

  @keyframes bounce {
    0%, 40%, 100% {
      transform: translateY(0);
    }
    20% {
      transform: translateY(-8px);
    }
  }

  .user-msg {
    display: block;
  }

  .msg {
    border: 1px solid rgb(133, 133, 133);
    border-radius: 8px;
    padding: 20px;
  }

  code[class*="language-"] > ul:not(:first-child),
  code[class*="language-"] > ol:not(:first-child) {
    padding-left: 40px;
  }

  code[class*="language-"] > hr:first-child {
    display: none !important;
    opacity: 0;
  }

  pre[class*="language-" ],
  code[class*="language-"] {
    background: #02131f;
    box-sizing: border-box;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    font-size: 18px;
    overflow: auto;
    white-space: normal;
    word-break: break-word;

    ol {
      margin-left: 40px;
    }
    ul {
      margin-left: 40px;
    }
    dl {
      margin-left: 40px;
    }

    &:deep(ul, ol, dl) {
      padding-left: 40px;
      // padding-left: 1rem;
      list-style-position: outside;
    }
  }
</style>